import gql from 'graphql-tag';

export default gql`
  mutation DeleteFlow($accountId: ID!, $id: ID!) {
    deleteFlow(accountId: $accountId, id: $id) {
      __typename
    }
  }
`;
